$('#product-search-button').click( function () {
  var product = $('#product-search-input');
  product.toggleClass('b-product-search--hidden');
})

$('#profession-picker-button').click( function () {
  var profession = $('#profession-picker');
  profession.toggleClass('hide');
})
